import React, { useCallback, useEffect, useState } from 'react'
import { isFerryPassageRequired } from 'assets/ferryPassageSuggestionMap'
import { isCustomControlRequired } from 'assets/customsControlSuggestionMap'
import { PrimaryButton } from 'components/Shared/PrimaryButton'
import { ReactComponent as AddIcon } from 'assets/icons/add-red.svg'
import styles from './OrderPointsSuggestions.module.css'
import { useTranslation } from 'react-i18next'

export function OrderPointsSuggestions ({ points, index, addFerry, addCustomsControl }) {
  const [displayFerrySuggestion, setDisplayFerrySuggestion] = useState(false)
  const [displayCustomsControlSuggestion, setDisplayCustomsControlSuggestion] = useState(false)
  const { t } = useTranslation()

  function isLoadingOrUnloading (point) {
    return point && (point.type === 'LOADING' || point.type === 'UNLOADING')
  }

  function isFerryPassage (point) {
    return point && point.type === 'FERRY_PASSAGE'
  }

  function isCustomsControl (point) {
    return point && point.type === 'CUSTOMS_CONTROL'
  }

  const findFirstLoadingOrUnloadingPoint = useCallback((points) => {

    const nextLoadingOrUnloadingPointIndex = points.findIndex(point => isLoadingOrUnloading(point))
    if (nextLoadingOrUnloadingPointIndex === -1) {
      return [null, -1]
    }
    return [points[nextLoadingOrUnloadingPointIndex], nextLoadingOrUnloadingPointIndex]
  }, [])

  const isRequiredCustomsControlSuggestion = useCallback((points, index) => {
    const startPoint = points[index - 1]
    if (!isLoadingOrUnloading(startPoint)) {
      return false
    }
    const nextPoints = points.slice(index)

    const [nextLoadingOrUnloadingPoint, nextLoadingOrUnloadingPointIndex] = findFirstLoadingOrUnloadingPoint(nextPoints)

    if (nextLoadingOrUnloadingPoint == null) {
      return false
    }

    const customControlBetween = nextPoints.slice(0, nextLoadingOrUnloadingPointIndex).find(point => isCustomsControl(point))

    if (customControlBetween) {
      return false
    }

    return isCustomControlRequired(startPoint.deliveryPointDetails.country, nextLoadingOrUnloadingPoint.deliveryPointDetails.country)
  }, [findFirstLoadingOrUnloadingPoint])

  const isRequiredFerrySuggestion = useCallback((points, index) => {

    const startPoint = points[index - 1]
    if (!isLoadingOrUnloading(startPoint)) {
      return false
    }

    const nextPoints = points.slice(index)

    const [nextLoadingOrUnloadingPoint, nextLoadingOrUnloadingPointIndex] = findFirstLoadingOrUnloadingPoint(nextPoints)
    if (nextLoadingOrUnloadingPoint == null) {
      return false
    }
    const ferryPassageBetween = nextPoints.slice(0, nextLoadingOrUnloadingPointIndex).find(point => isFerryPassage(point))

    if (ferryPassageBetween) {
      return false
    }

    return isFerryPassageRequired(startPoint.deliveryPointDetails.country, nextLoadingOrUnloadingPoint.deliveryPointDetails.country)

  }, [findFirstLoadingOrUnloadingPoint])

  useEffect(() => {
    if (index === 0) {
      setDisplayCustomsControlSuggestion(false)
      setDisplayFerrySuggestion(false)
    } else {
      setDisplayFerrySuggestion(isRequiredFerrySuggestion(points, index))
      setDisplayCustomsControlSuggestion(isRequiredCustomsControlSuggestion(points, index))
    }
  }, [points, index, isRequiredFerrySuggestion, isRequiredCustomsControlSuggestion])

  if (!displayCustomsControlSuggestion && !displayFerrySuggestion) {
    return null
  }

  return <div className={styles.root}>
    {displayFerrySuggestion && <div className="col my-3">
      <div className="row my-2"><h2 className="m-0">{t('form.order.cargo.add.ferryPassageSuggestion')}</h2>
      </div>
      <div className="row my-2">
        <PrimaryButton
          type="button"
          label={t('form.order.cargo.add.ferryPassage')}
          onClick={() => addFerry(index)}
          icon={<AddIcon className={styles.addSuggestionButton}/>}
          className={styles.suggestionButton}
        />
      </div>
    </div>
    }

    {displayCustomsControlSuggestion && <div className="col my-3">
      <div className="row my-2"><h2 className="m-0">{t('form.order.cargo.add.customsControlSuggestion')}</h2>
      </div>
      <div className="row my-2">
        <PrimaryButton
          type="button"
          label={t('form.order.cargo.add.customsControl')}
          onClick={() => addCustomsControl(index)}
          icon={<AddIcon className={styles.addSuggestionButton}/>}
          className={styles.suggestionButton}
        />
      </div>
    </div>
    }
  </div>

}
